module.exports = __webpack_public_path__ + "media/images/top/common/img_feature01-cfd3cfb93e0afdcfeee117015384db56.png";